export const ANALYTICS_SOURCES = {
    TRY_ON: 'TRY_ON',
};

export const EVENTS = {
    AVATAR_LOGO_CLICK: 'TRY_ON_AVATAR_LOGO_CLICK',
    CONTACT_US_BUTTON_CLICK: 'TRY_ON_CONTACT_US_BUTTON_CLICK',
    UPLOAD_MODEL: 'TRY_ON_UPLOAD_MODEL',
    UPLOAD_CLOTHES: 'TRY_ON_UPLOAD_CLOTHES',
    GENERATE_IMAGE: 'TRY_ON_GENERATE_IMAGE',
    DOWNLOAD_IMAGE: 'TRY_ON_DOWNLOAD_IMAGE',
    DOWNLOAD_VIDEO: 'TRY_ON_DOWNLOAD_VIDEO',
    GENERATE_VIDEO: 'TRY_ON_GENERATE_VIDEO',
    IMAGE_GENERATION_ERROR: 'TRY_ON_IMAGE_GENERATION_ERROR',
    VIDEO_GENERATION_ERROR: 'TRY_ON_VIDEO_GENERATION_ERROR',
    IMAGE_GENERATION_SUCCESS: 'TRY_ON_IMAGE_GENERATION_SUCCESS',
    VIDEO_GENERATION_SUCCESS: 'TRY_ON_VIDEO_GENERATION_SUCCESS',
};

const analyticsConfig = {
    mixPanel: {
        token: '1bc8bc2287770454294d6825cb36ea90',
        initConfig: {
            // debug: false,
            // track_pageview: true, removing it as it was requested from analytics team to reduse unwanted event.
            persistence: 'localStorage',
            api_host: 'https://analyzeia.avataar.ai',
            record_sessions_percent: 100,
            record_mask_text_selector: '',
            record_block_selector: '',
            record_idle_timeout_ms: 1800000, // 30 minutes Duration of inactivity in milliseconds before ending a contiguous replay. A new replay collection will start when active again.
        },
    },
};

export { analyticsConfig };